import { useTranslate } from "@similarweb/i18n-provider";
import { AvatarName, AvatarNameCounter, AvatarNameGroup } from "@similarweb/ui-components";

import { buildAvatarNamePreview } from "app/pages/sales-intelligence/domain/teams/utils/buildAvatarNamePreview";
import type { TeamListItem } from "app/pages/sales-intelligence/domain/teams/types/team-list-item";

type TerritoryMembersPreviewProps = {
    readonly team: TeamListItem;
};

export const TerritoryMembersPreview = ({ team }: TerritoryMembersPreviewProps) => {
    const { translate } = useTranslate();

    const memberCount = team.membersCount;
    const namedMembers = (team.previewMembers ?? []).filter((member): member is { userId: number; name: string } =>
        Boolean(member.name?.trim()),
    );
    const extraMembersCount = Math.max(memberCount - namedMembers.length, 0);
    const moreLabel =
        extraMembersCount > 0
            ? translate("si.management.teams.detail.members_preview.more", { count: extraMembersCount })
            : null;
    const { firstName, remainingNames } = buildAvatarNamePreview(
        namedMembers.map((member) => member.name),
        memberCount,
        moreLabel,
    );

    if (firstName === undefined) {
        return null;
    }

    return (
        <AvatarNameGroup data-automation={`industry-transition-impact-report-territory-members-${team.teamId}`}>
            <AvatarName name={firstName} />
            <AvatarNameCounter names={remainingNames} />
        </AvatarNameGroup>
    );
};
